import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputPrefix: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Prefix:">
    {form.getFieldDecorator('prefix', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="Prefix (Dr., Mr., Mrs., etc.)" />)}
  </Form.Item>
);
